/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotSlider = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'SLIDER',
]);

export default [
  ...[
    ['FieldRadio', {
      label: null,
      name: 'slider_direction',
      initialValue: 'HORIZONTAL',
      block: true,
      choices: ['Horizontal', 'Vertical'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
    }],
    getFilterWithCol(['FieldRadio', {
      label: null,
      name: 'slider_autoplay',
      initialValue: false,
      block: true,
      choices: [{
        label: 'Autoplay Off',
        value: false,
      }, {
        label: 'Autoplay On',
        value: true,
      }],
    }], 12),
    getFilterWithCol(['FieldRadio', {
      label: null,
      name: 'slider_loop',
      initialValue: false,
      block: true,
      choices: [{
        label: 'Loop Off',
        value: false,
      }, {
        label: 'Loop On',
        value: true,
      }],
    }], 12),
    ['FieldText', {
      label: null,
      name: 'slider_gap',
      prefix: 'Gap:',
      align: 'right',
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotSlider, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderItems', {
    name: 'slider_items',
    preSkip: [isNotSlider],
  }],
];
